// Modules
import { gql } from '@apollo/client'

export const AuthenticateWithReCaptcha = gql`
    mutation authenticateWithReCaptcha(
        $username: String!
        $password: String!
        $recaptchaToken: String!
        $uniqueAccess: Boolean!
        $keepLogged: KeepLogged
        $logInfo: LogInfoInput
    ) {
        authenticateWithReCaptcha(
            username: $username
            password: $password
            recaptchaToken: $recaptchaToken
            uniqueAccess: $uniqueAccess
            keepLogged: $keepLogged
            logInfo: $logInfo
        ) {
            access_token
            refresh_token
            uuid
        }
    }
`

export const AuthenticateCIPWithRecaptcha = gql`
    mutation authenticateCIPWithReCaptcha(
        $cip: String!
        $password: String!
        $dateOfBirth: String!
        $lab: String!
        $recaptchaToken: String!
        $isInvalid: Boolean
    ) {
        authenticateCIPWithReCaptcha(
            cip: $cip
            password: $password
            dateOfBirth: $dateOfBirth
            lab: $lab
            recaptchaToken: $recaptchaToken
            isInvalid: $isInvalid
        ) {
            accessToken
        }
    }
`

export const AuthenticateHash = gql`
    mutation authenticateHash($hash: String!) {
        authenticateHash(hash: $hash) {
            accessToken
            refreshToken
            type
        }
    }
`
export const GenerateUniqueToken = gql`
    mutation($accessToken: String!, $refreshToken: String!) {
        generateUniqueToken(accessToken: $accessToken, refreshToken: $refreshToken) {
            token
        }
    }
`

export const AuthenticateUniqueToken = gql`
    mutation($uniqueToken: String!) {
        authenticateUniqueToken(uniqueToken: $uniqueToken) {
            accessToken
            refreshToken
        }
    }
`

export const AuthenticateWithLink = gql`
    mutation authenticateWithMagicLink($magicLinkId: String!, $federalTaxId: String!) {
        authenticateWithMagicLink(magicLinkId: $magicLinkId, federalTaxId: $federalTaxId) {
            accessToken
            refreshToken
        }
    }
`

export const UpdatePatientConfig = gql`
    mutation updatePatientConfig($key: String!, $value: StringOrNumberOrBoolean!) {
        updatePatientConfig(key: $key, value: $value) {
            status
        }
    }
`

export const ViewerFeatureFlag = gql`
    query viewer {
        viewer {
            featureFlags {
                key
                value
            }
        }
    }
`

export const LogoutAccount = gql`
    mutation logoutAccount($uuid: String!) {
        logoutAccount(uuid: $uuid) {
            status
        }
    }
`
